import {CLStore} from 'common/src/redux/store';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {PromptToCardAgentStatus} from '../../../promptToCardAgent/promptToCardAgent';
import tryPatchingCardAndReportResults from './tryPatchingCardAndReportResults';
import {BaseCardScratchpadState} from '../../scratchpad/baseCardScratchpad.types';
import {SupportedCardType} from '../../promptToCardAgentV2.types';

export default async function postProcessStandaloneAgent<
  TScratchpad extends BaseCardScratchpadState,
>({
  result,
  scratchpad,
  store,
  cardId,
}: {
  result: {status: PromptToCardAgentStatus; chainOfThoughts: string};
  scratchpad: TScratchpad;
  store: CLStore;
  cardId: number;
}) {
  const {status, chainOfThoughts} = result;

  const card = scratchpad.card;

  if (!card) {
    throw new Error('Card was not found in state');
  }

  if (status === PromptToCardAgentStatus.NoAction) {
    return toolResult(JSON.stringify({status, chainOfThoughts}));
  }

  return tryPatchingCardAndReportResults(store, card as SupportedCardType, cardId, chainOfThoughts);
}
